// Re-export ISeoInfo from the API types

export interface ISeoInfo extends Components.Schemas.ISeoInfo { }

export enum ESeoPageType {
    SEARCH = 'SEARCH',
    FILTER = 'FILTER'
}

export interface IFilter {
    name: string
    values: string[]
}

export interface ISelectedFilter {
    name: string
    selectedValues: string[]
}

export interface ISeoPage {
    _id: string
    name: string
    type: ESeoPageType
    url: string
    searchQuery?: string
    subCategory_id?: string
    filters: IFilter[]
    seoInfo: ISeoInfo
    createdAt: string
    updatedAt: string
}

// API Request/Response interfaces
export interface ISeoPageQueryRequest {
    skip: number
    limit: number
    name?: string
    url?: string
    type?: ESeoPageType
}

export interface ISeoPageQueryResponse {
    seoPages: ISeoPage[]
    count: number
}

export interface ICreateSeoPageRequest {
    name: string
    subCategory_id: string
    url: string
    filters: IFilter[]
    seoInfo: ISeoInfo
}

export interface IUpdateSeoPageRequest {
    name?: string
    searchQuery?: string
    url?: string
    subCategory_id?: string
    filters?: IFilter[]
    seoInfo?: Partial<ISeoInfo>
}

export interface ISubCategoryFilter {
    name: string
    values: string[]
}

export interface IFilterValueCount {
    name: string
    value: string
    count: number
}

// Form interfaces
export interface ISeoPageFormData {
    name: string
    searchQuery?: string
    subCategoryId: string
    url: string
    filters: ISelectedFilter[]
    seoInfo: {
        title?: string
        desc?: string
        h1?: string
        seoText?: string
    }
}

export interface ISeoPagesList {
    pages: ISeoPage[]
    loading: boolean
    selectedIds: string[]
    onSelectionChange: (ids: string[]) => void
    onDelete: (ids: string[]) => void
    onSearch: (query: string) => void
    onFilter: (type: ESeoPageType) => void
}